module.exports = __webpack_public_path__ + "img/img123.3b764b70.svg";